import { z } from 'zod'

import { dataDisplayTypes } from '~/utils'

import { tableChartTypes } from '../../../utils'
import { type RestoringParams } from '../types'

export const schema2 = z.object({
  version: z.literal(2),
  revision: z.number(),
  tableChartType: z.enum(tableChartTypes),
  dataDisplayType: z.enum(dataDisplayTypes),
  isChartMaxUnified: z.boolean(),
  hiddenBrandIds: z.array(z.string()),
  hiddenLabelBrandIds: z.array(z.string()),
  hiddenSurveyIds: z.array(z.string()),
  comment: z.string().optional(),
  hash: z.string(),
}) satisfies z.ZodSchema<RestoringParams>
